<template>
    <div>
      <h1>Browser Fingerprint</h1>
      <p style="color: white">Хэш отпечатка: {{ hash }}</p>
    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        fingerprint: "", // Зберігання відбитка у форматі JSON
        hash: "", // Хешований відбиток
      };
    },
    methods: {
      async getFingerprint() {
        const data = {
          userAgent: navigator.userAgent,
          platform: navigator.platform,
          language: navigator.language,
          screenResolution: `${screen.width}x${screen.height}`,
          colorDepth: screen.colorDepth,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          hardwareConcurrency: navigator.hardwareConcurrency,
          deviceMemory: navigator.deviceMemory || "Unknown",
          webglRenderer: this.getWebGLRenderer(),
          canvasHash: this.getCanvasFingerprint(),
        };

        // Створюємо JSON-рядок
        const fingerprintString = JSON.stringify(data);

        // Зберігаємо оригінальний відбиток
        this.fingerprint = fingerprintString;

        // Хешуємо відбиток
        this.hash = await this.generateHash(fingerprintString);
      },
      getCanvasFingerprint() {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.textBaseline = "top";
        ctx.font = "14px Arial";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText("Hello World!", 2, 15);
        ctx.strokeStyle = "rgba(255,0,0,0.8)";
        ctx.strokeRect(125, 1, 62, 20);

        // Повертаємо вміст canvas у вигляді рядка
        return canvas.toDataURL();
      },
      getWebGLRenderer() {
        try {
          const canvas = document.createElement("canvas");
          const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
          const info = gl.getExtension("WEBGL_debug_renderer_info");
          return gl.getParameter(info.UNMASKED_RENDERER_WEBGL);
        } catch (e) {
          return "Not Supported";
        }
      },
      async generateHash(input) {
        // Перетворюємо рядок на масив байтів
        const encoder = new TextEncoder();
        const data = encoder.encode(input);

        // Створюємо хеш SHA-256
        const hashBuffer = await crypto.subtle.digest("SHA-256", data);

        // Перетворюємо хеш на рядок (hex)
        return Array.from(new Uint8Array(hashBuffer))
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");
      },
    },
    async mounted() {
      // Обчислюємо відбиток і хеш під час завантаження компонента
      await this.getFingerprint();
    },
  };
  </script>

  <style scoped>
  h1 {
    font-size: 24px;
    margin-bottom: 16px;
  }

  p {
    font-size: 18px;
  }
</style>
